export default __webpack_public_path__ + "static/media/issac2.41c48ab8.PNG";